import React from "react";
import GridAnimation from "./components/p5";

const AnimationBox = ({ children }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "relative", // Positioning context for absolute elements inside
        display: "flex", // Align child elements
        justifyContent: "start", // Horizontally center the content
        alignItems: "start", // Vertically center the content
         // Clip the animation and content within the box
      }}
    >
      {/* Grid Animation as a background */}
      <GridAnimation
        style={{
          position: "absolute", // Make sure the animation stays in the background
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: -1, // Place the animation behind the other content
        }}
      />

      {/* Normal content */}
      <div style={{ position: "absolute", zIndex: 2,width:"100%" , height:"100%" }}>
      {children} {/* Render the nested children content */}
      </div>
    </div>
  );
};

export default AnimationBox;
